// AUTO-GENERATED by scripts/count-docs-words.sh — do not edit.
// Refreshed only when the count changes.
export const DOCS_WORD_COUNT = 179983
export const DOCS_WORD_COUNT_GENERATED_AT = '2026-06-04T09:31:09Z'
